<div class="component-content">
  <div id="header-bar">
    <div id="header-title">
      <mat-icon class="icon-32" svgIcon="tasks"></mat-icon>
      <h2>Tasks</h2>
    </div>
    <div id="buttons" *ngIf="canShowButtons">
      <button class="lc-stroked-button lc-primary" *ngIf="accessService.canPauseTasks() && !isTasksProcessingPaused" mat-stroked-button (click)="pauseTasksProcessing()">
        <mat-icon svgIcon="pause-circle"></mat-icon>Pause
      </button>
      <button class="lc-stroked-button lc-primary" *ngIf="accessService.canPauseTasks() && isTasksProcessingPaused" mat-stroked-button (click)="startTasksProcessing()">
        <mat-icon svgIcon="start-circle"></mat-icon>Start
      </button>
    </div>
  </div>
</div>